module.exports = __webpack_public_path__ + "static/img/lightbulb_2.c1cb3e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lightbulb_2.png
// module id = veVl
// module chunks = 1